import Vue from 'vue';

/**
 * @description Название события открытия чата Мессенджеров.
 * @type {string}
 */
export const NAME_EVENT_OPEN_MESSENGERS_CHAT = 'open-messengers-chat';

/**
 * @description Название события открытия чата WA.
 * @type {string}
 */
export const NAME_EVENT_OPEN_WHATS_APP_CHAT = 'open-whats-app-chat';

// eslint-disable-next-line import/prefer-default-export
export const EventBus = new Vue();
